import {
  useAggregateGraphData,
  usePinkButtonClickData
} from "./ReportingVideoHooks";
import { useCombineOrigin } from "./ReportingOverviewHooks";
import moment from "moment";

const useReportingProduct = (
  {
    numberVideos: totalNumberOfVideos,
    numberViews: totalNumberOfViews,
    numberSales: totalNumberOfSales,
    salesAmount: totalSalesInDollars,

    totalViews,
    pinkButtonClicks,
    totalSalesCount,
    totalSales,
    originList,
    ...productReport
  },
  dateRange
) => {
  const totalVideosViewsGraphData = useAggregateGraphData(
    "viewCount",
    totalViews,
    {
      start: moment(dateRange[0]),
      end: moment(dateRange[1])
    }
  );

  const totalSalesCountGraphData = useAggregateGraphData(
    "salesCount",
    totalSalesCount,
    {
      start: moment(dateRange[0]),
      end: moment(dateRange[1])
    }
  );

  const totalDollarValueOfSalesGraphData = useAggregateGraphData(
    "salesAmount",
    totalSales,
    {
      start: moment(dateRange[0]),
      end: moment(dateRange[1])
    }
  );

  const standardizedOriginList = originList.map((origin) => ({
    id: origin.origin,
    origin: origin.origin,
    views: origin.totalViews
  }));

  const videoOriginListTableData = useCombineOrigin(standardizedOriginList);

  const pinkButtonClicksGraphData = usePinkButtonClickData(pinkButtonClicks);

  return {
    totalNumberOfVideos,
    totalNumberOfViews,
    totalNumberOfSales,
    totalSalesInDollars,
    totalVideosViewsGraphData,
    totalVideosViewsColor: "#ff7373",
    pinkButtonClicksGraphData,
    pinkButtonColor: "#c98eff",
    totalSalesCountGraphData,
    totalDollarValueOfSalesGraphData,
    videoOriginListTableData
  };
};

export default useReportingProduct;
